import { useCallback } from "react";
import { ConfirmAlert, SimpleAlert } from "../components/Alerts/Alerts";
import { useTranslationApp } from "../lib/i18next";
import {
  ERROR,
  GALLERY_FOLDERS_DELETE_ERROR,
  GALLERY_FOLDERS_DELETE_SUCCESS,
  GALLERY_FOLDERS_DELETE_TEXT,
  GALLERY_FOLDERS_DELETE_TITLE,
} from "../i18n/keysTranslations";

/**
 * Shared "delete folder" flow for every folder domain: asks for confirmation,
 * runs `deleteFolder({ folderID })` and reports the result. Deleting a folder
 * never deletes the entities inside it.
 */
export const useConfirmDeleteFolder = ({
  deleteFolder,
  onDeleted = () => {},
}) => {
  const { t } = useTranslationApp();

  return useCallback(
    async (folder) => {
      if (!folder?.id) return { ok: false };

      const confirmation = await ConfirmAlert({
        title: t(GALLERY_FOLDERS_DELETE_TITLE),
        text: t(GALLERY_FOLDERS_DELETE_TEXT, { name: folder.name }),
      });

      if (!confirmation?.isConfirmed) return { ok: false, cancelled: true };

      const response = await deleteFolder({ folderID: folder.id });

      if (!response?.ok) {
        await SimpleAlert({
          icon: "error",
          title: t(ERROR),
          text: t(GALLERY_FOLDERS_DELETE_ERROR),
        });
        return response;
      }

      onDeleted({ folder, response });

      await SimpleAlert({
        icon: "success",
        title: t(GALLERY_FOLDERS_DELETE_SUCCESS),
      });

      return response;
    },
    [deleteFolder, onDeleted, t]
  );
};
